import { errorViewHandler as errorViewHandlerCommon, } from '@zurich/ui/legacy/components';
import { FatalApiError, PermissionError } from '../../errors';
import { FatalApiErrorView } from './FatalApiErrorView';
import { PermissionErrorView } from './PermissionErrorView';
export const errorViewHandler = (error) => {
    if (error instanceof PermissionError)
        return PermissionErrorView;
    if (error instanceof FatalApiError)
        return FatalApiErrorView;
    return errorViewHandlerCommon(error);
};
